import { rootApi } from "../../api/rootApi";

export const participatingBrandsApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchAllParticipatingBrands: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/bikaji/brand/get`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),

    updateParticipatingBrand: builder.mutation({
      query: (params) => {
        return {
          method: "PUT",
          url: `/tenant/bikaji/brand/update`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body
        };
      },
    }),

    createParticipatingBrand: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/bikaji/brand/create`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body
        };
      },
    }),
  }),
});

export const {
  useFetchAllParticipatingBrandsMutation,
  useUpdateParticipatingBrandMutation,
  useCreateParticipatingBrandMutation,
} = participatingBrandsApi;
